module.exports = __webpack_public_path__ + "img/read_more.3bf43295.svg";